import { OccasionPage } from "@/components/public/OccasionPage"
import labelClub from "@/images/label-club.webp"
import labelHospitality from "@/images/label-hospitality.webp"

const DESCRIPTION =
  "Corporate branded wine for client gifts, staff milestones and completions: premium South African wine with your brand on every bottle, UK-wide."

export default function Corporate() {
  return (
    <OccasionPage
      title="Corporate Gifting"
      metaTitle="Corporate Branded Wine & Gifts"
      description={DESCRIPTION}
      lede="Client gifts, staff milestones and completion celebrations, with your brand on every bottle."
      heroImage={{
        src: labelHospitality,
        alt: "Bespoke corporate gift wine bottle with a custom label",
        width: 941,
        height: 1672,
      }}
      story={{
        eyebrow: "Corporate",
        heading: "A gift that says more than a card",
        paragraphs: [
          "A branded bottle says more than a card ever will. We work with businesses that want to mark a completed deal, a work anniversary or simply thank a client — and reach for a bottle carrying their own name or crest rather than a generic hamper.",
          "It suits any moment your brand wants to be remembered for: a sale completion, a product launch, a boardroom gift, a long-service award. The label is yours — we handle the wine and the printing.",
        ],
      }}
      cellar={{
        lede: "A small selection of bespoke bottles produced for clubs, schools and clubhouses across the United Kingdom.",
        bottles: [
          {
            src: labelClub,
            alt: "Members' club commemorative bottle",
            name: "Members' Club",
            place: "London",
          },
        ],
      }}
    />
  )
}
